import * as FCFS from '../constants/fcfs';


export default {
  /**
   * Mutate a list of queues.
   *
   * @param state
   * @param queues
   */
  [FCFS.MUTATE_LIST_QUEUE]: (state, queues) => {
    state.queues = queues;
  },

  /**
   * Mutate the last queue.
   * @param state
   * @param queue
   */
  [FCFS.MUTATE_LAST_QUEUE]: (state, queue) => {
    state.last_queue = queue;
  },

  [FCFS.MUTATE_QUEUE]: (state, data) => {
    state.queue = data;
  },

  /**
   * Update the queue item on the list.
   *
   * @param state
   * @param data
   */
  [FCFS.MUTATE_UPDATE_QUEUE_ITEM]: (state, data) => {
    const list = window._.cloneDeep(state.queues);

    if (data.props.status === 'delete') {
      list.data = window._.filter(list.data, i => i.id !== data.id);
    } else {
      const listItem = window._.findIndex(list.data, (i) => i.id === data.id);
      list.data[listItem] = {...list.data[listItem], ...data.props};
    }

    state.queues = list;
  }
}



// WEBPACK FOOTER //
// ./src/store/fcfs/mutations.js